module.exports = __webpack_public_path__ + "img/ic_shijuan_16.bfa0d978.svg";